import keys from 'lodash/keys'
import values from 'lodash/values'

import { IUser, AccountStatus } from 'cat-shared/utils'
import { ApiErrors, CreateQuestionFormValues } from 'client/utils'

export const getAccountStatus = (user: IUser): AccountStatus => {
  let accountStatus = AccountStatus.UNKNOWN

  if (user) {
    accountStatus = AccountStatus.CREATED
    if (user.config.confirmed) {
      accountStatus = AccountStatus.CONFIRMED
      if (user.config.payment) {
        accountStatus = AccountStatus.PAID
        if (user.config.payment.type === AccountStatus.FREE) {
          accountStatus = AccountStatus.FREE
        }
      }
    }
  }

  return accountStatus
}

export const parseApiErrors = (errors: ApiErrors): Record<string, string> => {
  const parsed = {}
  keys(errors).forEach(
    key => (parsed[String(key)] = errors[key].properties?.message || errors[key].message)
  )
  return parsed
}

export const createQuestionFormValuesToBody = (formValues: CreateQuestionFormValues) => {
  const { type, category, text, options, correctOptions, explanation } = formValues

  return {
    type,
    category,
    text,
    options: values(options).filter(o => o),
    correctOptions,
    explanation,
  }
}
